import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material';
import { MatCardModule } from '@angular/material';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
  imports: [
    MatProgressSpinnerModule,
    MatCardModule,
    MatDialogModule,
    MatProgressBarModule
  ],
  exports: [
    MatProgressSpinnerModule,
    MatCardModule,
    MatDialogModule,
    MatProgressBarModule
  ]
})
export class MaterialModule {}


// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/material.module.ts